import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ClientHeader from "../../components/Client/ClientHeader";
import StoreCard from "../../components/Client/StoreCard";
import { getStores } from "../../api/storeService";
import "../../components/Client/clientTheme.css";
import "./StoresList.css";

export default function StoresList() {
  const { t } = useTranslation(["storesList", "common"]);
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("categoryId") || undefined;
  const search = searchParams.get("search") || undefined;

  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getStores({ categoryId, search })
      .then(setStores)
      .catch(() => setStores([]))
      .finally(() => setLoading(false));
  }, [categoryId, search]);

  const title = search ? t("storesForSearch", { search }) : t("allStores");

  return (
    <div className="client-stores-page">
      <ClientHeader />
      <div className="client-stores-content">
        <h1 className="client-stores-title">{title}</h1>

        {loading ? (
          <p className="client-stores-status">{t("common:loading")}</p>
        ) : stores.length === 0 ? (
          <p className="client-stores-status">{t("noStoresFound")}</p>
        ) : (
          <div className="client-stores-grid">
            {stores.map((store) => (
              <StoreCard store={store} key={store.storeId} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
